import { ComponentPropsWithRef, FC } from 'react';
import s from './Card.module.scss';
import cn from 'classnames';

interface Props extends ComponentPropsWithRef<'div'> {
	variant?: 'primary' | 'light' | 'pale_primary' | 'pale_gray';
	padding?: 'thick' | 'thin';
	shadow?: boolean;
}

export const Card: FC<Props> = (props) => {
	const {
		className, //
		variant = 'light',
		padding = 'thin',
		shadow = false,
		...divProps
	} = props;

	return (
		<div
			{...divProps}
			className={cn(s.card, s[`card_${variant}`], padding && s[`card_padding_${padding}`], shadow && s.card_shadow, className)}
		/>
	);
};
